import { AxiosResponse } from 'axios';
import client from '../../lib/service/order.service';
import { Order, OrderResponse } from './order.types';

const ORDERS = 'v1/order';

export const getOrder = async (orderUuid: string): Promise<Order> => {
  const response = await client.get<OrderResponse>(ORDERS, {
    headers: {
      'order-uuid': orderUuid,
    },
  });
  return response.data.order;
};

export const updateOrder = async (
  order: Order,
  orderUuid: string,
): Promise<Order> => {
  const response = await client.put<Order, AxiosResponse<OrderResponse>>(
    ORDERS,
    order,
    {
      headers: {
        'order-uuid': orderUuid,
      },
    },
  );
  return response.data.order;
};
